module.exports = __webpack_public_path__ + "img/p3_2.56598ce0.png";